import './styling.scss';
import * as template from './template.html';
import { getOverviewSref } from 'components/navigation/shared/states';
import * as componentsModule from './components';
import * as angular from 'angular';
import { getActionableCustomerPolicyInfos, getHistoricalCustomerPolicyInfos } from 'utilities/policyInfosHelper';
import { CurrentUserService } from 'services/currentUser';
import { FlagshipService } from 'services/flagship';
import { checkFeatureFlagAndRedirect } from 'utilities/featureFlags';

const module = angular.module('policies-page', [componentsModule.module.name]);

interface PoliciesPageController extends angular.IStrictController {
    policyInfos: Array<CustomerPolicyInfo>;
    actionablePolicyInfosWithIndexes: Array<CustomerPolicyInfoWithIndex>;
    historicalPolicyInfosWithIndexes: Array<CustomerPolicyInfoWithIndex>;
    getPolicySref: typeof getOverviewSref;
    getPoliciesHistorySectionMode(): 'page' | 'section';
}

module.component('policiesPage', {
    template: template,
    bindings: {
        policyInfos: '<'
    },
    controller: function(
        this: PoliciesPageController,
        currentUserService: CurrentUserService,
        flagshipService: FlagshipService,
        $window: angular.IWindowService,
        $scope: angular.IScope
    ) {
        const checkFeatureFlag = () => {
            checkFeatureFlagAndRedirect('ReactPolicyList', flagshipService, $window, currentUserService);
        };
        this.$onInit = () => {
            if (flagshipService.getFeatureFlagStatus() === 'FeatureFlagStatus:Ready') {
                checkFeatureFlag();
            } else {
                $scope.$on('FeatureFlagStatus:Ready', () => {
                    checkFeatureFlag();
                });
            }
            this.getPolicySref = getOverviewSref;

            const customerPolicyInfosWithIndexes = currentUserService.getIndexedCustomerPolicyInfos(this.policyInfos);

            this.actionablePolicyInfosWithIndexes = getActionableCustomerPolicyInfos(customerPolicyInfosWithIndexes);
            this.historicalPolicyInfosWithIndexes = getHistoricalCustomerPolicyInfos(customerPolicyInfosWithIndexes);

            this.getPoliciesHistorySectionMode = function() {
                if (this.actionablePolicyInfosWithIndexes.length > 0) {
                    return 'section';
                } else {
                    return 'page';
                }
            };
        };
    }
});

export { module };
